<template>
  <div class="wrapper">
    <BasePieChart :list="data.list" class="pie-chart"></BasePieChart>
    <div class="list">
      <div class="list__header">
        <div class="list__cell list__cell-score">Keyword Relevancy Score</div>
        <div class="list__cell list__cell-msv">MSV</div>
        <div class="list__cell list__cell-keywords"># of Keywords</div>
      </div>
      <div class="list__row" v-for="(item, index) in list" :key="item.score">
        <span class="list__item-color" :style="getItemColorClass(index)"></span>
        <div class="list__cell list__cell-score">{{item.score}}</div>
        <div class="list__cell list__cell-msv">{{item.value | roundNumber | commaDividedNumber}}</div>
        <div class="list__cell list__cell-keywords">{{item.keywords | commaDividedNumber}}</div>
      </div>
      <div class="list__footer">
        <div class="list__cell list__footer-cell-score">Total</div>
        <div class="list__cell list__cell-msv">{{total.msv | roundNumber | commaDividedNumber}}</div>
        <div class="list__cell list__cell-keywords">{{total.keywords | commaDividedNumber}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { allColors } from '@/common/BasePieChart'
import filters from '@/common/Filters'
// eslint-disable-next-line no-unused-vars
import RelevancyReport from '../../relevancy/RelevancyReport'

/**
 * Relevancy Score Breakdown statistic
 * used in {@link RelevancyReport} component
 */
export default {
  name: 'PieChart',
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  computed: {
    charData () {
      return this.handlePropsData()
    },
    list () {
      return this.data.list
    },
    total () {
      return this.data.total
    }
  },
  methods: {
    handlePropsData () {
      return _.cloneDeep(this.data)
    },
    getItemColorClass (index) {
      return { 'background-color': allColors[ index ] }
    }
  },
  filters: {
    roundNumber: filters.roundNumber,
    commaDividedNumber: filters.commaDividedNumber
  }

}
</script>

<style scoped lang="scss">

  .wrapper {
    display: flex;
    width: 100%;
    justify-content: stretch;
  }

  .list {
    padding: 30px 40px;
    flex: 1 1 70%;
    display: flex;
    flex-direction: column;

    &__header,
    &__footer,
    &__row {
      display: flex;
      font-size: 12px;
      color: $rfx-dark-march;
      padding: 0 16px;
      height: 30px;
    }

    &__row {
      font-weight: 500;
    }

    &__header {
      border-bottom: 1px solid $rfx-grey;

      .list__cell-score {
        flex-basis: 55%;
      }
    }

    &__cell {
      display: flex;
      align-items: center;
    }

    &__item {
      &-color {
        width: 10px;
        height: 10px;
        border-radius: 50%;
        display: inline-block;
        margin: auto 10px auto 0;
        flex-shrink: 0;
      }
    }

    &__footer,
    &__header {
      font-size: 12px;
      font-weight: bold;
      color: $rfx-dark-march;
    }

    &__footer {
      display: flex;
      justify-content: stretch;
      border-top: 1px solid $rfx-grey;
    }
    &__footer-cell-score,
    &__cell-score {
      flex: 1 1 55%;
    }

    &__cell-score {
      flex-basis: 53%;
    }

    &__footer-cell-score {
      padding-right: 20px;
      box-sizing: border-box;
      justify-content: flex-end;
    }

    &__cell-msv {
      flex: 1 1 53%;
    }

    &__cell-keywords {
      flex: 1 1 11%;
      min-width: 90px;
      display: flex;
      justify-content: flex-start;

    }

  }

  .pie-chart {
    flex: 1 1 30%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>
